import { createTheme } from "@mui/material";

const theme = createTheme({
  palette: {
    primary: {
      main: "#ecac35",
    },
    secondary: {
      main: "#1a1a1a",
    },
    info: {
      main: "#ECAC35",
    },
    success: {
      main: "#00C9A5",
    },
    error: {
      main: "#E3597A",
    },
    warning: {
      main: "#F9F871",
    },
  },
});

export default theme;
